import { InsuranceInformationConstants } from '../store/insuranceInformation.constants'

export const insuranceInformationSchemas = [
  {
    inputKey: InsuranceInformationConstants.SET_INSURANCE_CARRIER,
    isNumber: false,
    type: 'object',
    properties: {
      SET_INSURANCE_CARRIER: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,100}$',
      },
    },
    additionalProperties: false,
    required: ['SET_INSURANCE_CARRIER'],
    errorMessage: {
      properties: {
        SET_INSURANCE_CARRIER: 'Must be alphanumeric with max length of 100',
      },
    },
  },
  {
    inputKey: InsuranceInformationConstants.SET_GROUP_NAME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_GROUP_NAME: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,30}$',
      },
    },
    additionalProperties: false,
    required: ['SET_GROUP_NAME'],
    errorMessage: {
      properties: {
        SET_GROUP_NAME: 'Must be alphanumeric with max length of 30',
      },
    },
  },
  {
    inputKey: InsuranceInformationConstants.SET_GROUP_NUMBER,
    isNumber: false,
    type: 'object',
    properties: {
      SET_GROUP_NUMBER: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_GROUP_NUMBER'],
    errorMessage: {
      properties: {
        SET_GROUP_NUMBER: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: InsuranceInformationConstants.SET_POLICY,
    isNumber: false,
    type: 'object',
    properties: {
      SET_POLICY: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_POLICY'],
    errorMessage: {
      properties: {
        SET_POLICY: 'Must be alphanumeric with max length of 50',
      },
    },
  },
]
